import React from "react";
import {useTranslation} from "@unibuddy/intl";
import {Label, Stack, TextInput, Tiles} from "@unibuddy/patron";

import {CurrentFiltersType} from "../page/ContentListPage";
import {TopicInput} from "../components/TopicInput";
import {DegreeInput} from "../components/DegreeInput";
import {SortInput} from "../components/SortInput";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_SEARCH} from "../../../../translations/blogs";
import {AllPostsField} from "../../../../types/generated";

export type FilterContainerProps = {
    data?: {allPostsInfo: AllPostsField};
    loading: boolean;
    currentFilters: CurrentFiltersType;
    searchValue: string;
    setSearchValue: React.Dispatch<React.SetStateAction<string>>;
    onSearchOrFilter: (filterInput: string, filterName: string) => void;
};

export function FilterContainer({
    data,
    loading,
    currentFilters,
    searchValue,
    setSearchValue,
    onSearchOrFilter,
}: FilterContainerProps) {
    const {t} = useTranslation([IntlNamespaces.BLOGS]);
    return (
        <Stack space="medium">
            <Stack space="small">
                <Label id="search">{t(INTL_SEARCH.key, INTL_SEARCH.defaultValue)}</Label>
                <TextInput
                    id="search"
                    aria-label={t(INTL_SEARCH.key, INTL_SEARCH.defaultValue)}
                    placeholder={t(INTL_SEARCH.key, INTL_SEARCH.defaultValue)}
                    onChange={(e: {target: {value: string}}) => setSearchValue(e.target.value)}
                    value={searchValue}
                />
            </Stack>
            <Tiles columns={[1, 2, 3]} space="medium">
                <TopicInput
                    currentTopic={currentFilters.topics ?? ""}
                    selectableTopicIds={data?.allPostsInfo?.blogPostsTopics ?? []}
                    onSearch={onSearchOrFilter}
                    containerLoading={loading}
                />
                <DegreeInput
                    currentDegree={currentFilters.degrees ?? ""}
                    selectableDegrees={data?.allPostsInfo?.blogPostsDegrees ?? []}
                    onSearch={onSearchOrFilter}
                    containerLoading={loading}
                />
                <SortInput currentSort={currentFilters.sort ?? ""} onSearch={onSearchOrFilter} />
            </Tiles>
        </Stack>
    );
}
